module.exports = __webpack_public_path__ + "img/PL08525.8acf0cdd.svg";